import type { Props } from './types';

import { styled } from 'styled-components';

import IconDone from '../../../assets/icons/done-icon-gray.svg?react';
import { LeftColSC } from '../common/Common';

const DesktopNavSC = styled.div`
  display: none;
  color: ${(props) => props.theme.colors.oxfordBlue[50]};
  width: 100%;

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    display: block;
  }
`;

const DesktopNavContentSC = styled.div`
  width: 100%;
  max-width: ${(props) => `calc(${props.theme.dimensions.containerMaxWidth} - 2rem)`};
  margin: 0 auto;
  display: flex;
  position: relative;
`;

const ListSC = styled.ul`
  list-style: none;
  margin: 0 auto;
  display: flex;

  > li:last-child {
    margin-inline-end: 0;
  }
`;

const ListItemSC = styled.li<{ $isActive?: boolean }>`
  display: inline-flex;
  align-items: center;
  margin-inline-end: 2.5rem;
  color: ${(props) => (props.$isActive ? props.theme.colors.white : props.theme.colors.oxfordBlue[50])};
`;

const DesktopOrderSC = styled.span<{ $isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.$isActive ? props.theme.colors.white : props.theme.colors.oxfordBlue[80])};
  color: ${(props) => (props.$isActive ? props.theme.colors.oxfordBlue[100] : props.theme.colors.oxfordBlue[30])};
  border-radius: 50%;
  width: 1.25rem;
  height: 1.25rem;
  margin-inline-end: 0.5rem;

  font-size: ${(props) => props.theme.fontSizes.xs};
  font-weight: 600;
  line-height: ${(props) => props.theme.lineHeights.xxs};
`;

const getStepIdOrIcon = (stepId: number, currentStep: number) => {
  if (stepId < currentStep) {
    return <IconDone />;
  }

  return stepId;
};

const DesktopNav = ({ backButton, currentStep, steps }: Props) => {
  return (
    <DesktopNavSC>
      <DesktopNavContentSC>
        {backButton && <LeftColSC>{backButton}</LeftColSC>}
        <ListSC>
          {Object.entries(steps).map(([id, name]) => {
            const stepId = Number(id);

            return (
              <ListItemSC key={id} $isActive={stepId <= currentStep}>
                <DesktopOrderSC $isActive={stepId === currentStep}>
                  {getStepIdOrIcon(stepId, currentStep)}
                </DesktopOrderSC>
                {name}
              </ListItemSC>
            );
          })}
        </ListSC>
      </DesktopNavContentSC>
    </DesktopNavSC>
  );
};

export default DesktopNav;
